import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // FailureBanner
    retry: 'Повторить',
    answerQuestion: 'Ответить на вопрос',
    showRun: 'Показать запуск',
    setImageStyle: 'Задать стиль картинок',
    topUp: 'Пополнить',
    // CreditsChip
    credits: 'Кредиты',
    creditsHint: (balance: string) => `Кредиты: ${balance}`,
    creditsHintHeld: (balance: string, held: string) =>
      `Кредиты: ${balance}, заморожено ${held} под идущим запуском`,
    // QuotePlate
    runPrice: (price: string) => `Запуск: ${price}`,
    balance: (balance: string) => `· Баланс: ${balance}`,
    notEnoughCredits: 'не хватает кредитов',
  },
  en: {
    retry: 'Retry',
    answerQuestion: 'Answer the question',
    showRun: 'View run',
    setImageStyle: 'Set image style',
    topUp: 'Top up',
    credits: 'Credits',
    creditsHint: (balance: string) => `Credits: ${balance}`,
    creditsHintHeld: (balance: string, held: string) =>
      `Credits: ${balance}, ${held} held for a run in progress`,
    runPrice: (price: string) => `Cost: ${price}`,
    balance: (balance: string) => `· Balance: ${balance}`,
    notEnoughCredits: 'not enough credits',
  },
})
